import { InputValidator } from './InputValidator'

export abstract class StringValidator implements InputValidator {
    isValid = (value: unknown) => {
        if (!value) return true
        return this.isValidString(`${value}`)
    }

    abstract isValidString(value: string): boolean
    abstract getMessage(): string
}
